import React from 'react';
import { Button, Table } from 'react-bootstrap';
import ConnectionCard from './components/ConnectionCard';
import DeleteModal from './modals/DeleteModal';
import withRouter from '../../../../util/WithRouter';
import { withFacebookAuth } from './hoc/withFacebookAuth';
import ThirdPartyAPI from '../../../../api/ThirdPartyAPI';
import Const from '../../../../util/Constants';
import Util from '../../../../util/Util';
import { NavLink } from 'react-router-dom';
import { FaCogs } from 'react-icons/fa';
class FacebookList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mappings: [],
      inApiCall: false,
      showDelete: false,
      deleteId: null
    };
  }

  componentDidMount() {
    this.loadMappings();
  }

  componentDidUpdate(prevProps) {
    // Reload mappings if auth status changes to connected
    if (prevProps.fbAuth.connectionStatus !== this.props.fbAuth.connectionStatus && 
        this.props.fbAuth.connectionStatus === 'connected') {
      this.loadMappings();
    }
  }

  loadMappings = () => {
    this.setState({ inApiCall: true });
    // Use your existing generic API service to fetch all api_model rows
    ThirdPartyAPI.list(
      Const.Facebook,
      (res) => {
        const fbMappings = (res || []).filter(m => m.party_type === Const.Facebook);
        this.setState({ mappings: fbMappings, inApiCall: false });
      },
      (err) => { 
        console.log({loadMappings: err}); 
        this.setState({ inApiCall: false }) 
      }
    );
  };

  deleteMapping = () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    this.setState({ inApiCall: true, showDelete: false });
    
    // Use your existing generic API service to delete (sets status to Trash)
    ThirdPartyAPI.delete(
      deleteId,
      () => {
        this.setState({ deleteId: null, inApiCall: false });
        this.loadMappings();
      },
      (err) => {
        Util.showError("Failed to delete mapping");
        this.setState({ inApiCall: false });
      }
    );
  };

  closeDelete = () => this.setState({ showDelete: false, deleteId: null });

  render() {
    const { fbAuth } = this.props;
    const { mappings, inApiCall, showDelete } = this.state;
    const isConnected = fbAuth.connectionStatus === 'connected';

    return (
      <div className="container-fluid">
        {/* Auth UI */}
        <ConnectionCard
          status={fbAuth.connectionStatus} 
          info={fbAuth.connectionInfo}
          tokenExpiry={fbAuth.tokenExpiry}
          configLoaded={fbAuth.configLoaded}
          inApiCall={fbAuth.isAuthLoading || inApiCall}
          onConnect={fbAuth.connectFacebook} 
          onDisconnect={fbAuth.disconnectAccount}
          onRefresh={fbAuth.refreshToken}
        />
        
        {/* Mapping UI (Only shows if connected) */}
        {isConnected && (
          <div className="card mt-4">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h4 className="mb-0">Mapped Lead Forms</h4>
              <Button 
                variant="primary" 
                onClick={() => this.props.navigate('mapping/0')} // 0 = Add New
                disabled={inApiCall}
              >
                + Add New Mapping
              </Button>
            </div>
            <div className="card-body">
              {inApiCall && mappings.length === 0 ? (
                <p className="text-center">Loading mappings...</p>
              ) : mappings.length === 0 ? (
                <p className="text-center text-muted">No forms mapped yet. Click "Add New Mapping" to get started.</p>
              ) : (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Page</th>
                      <th>Form</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mappings.map((item) => {
                      let apiData = {};
                      try { apiData = JSON.parse(item.api_data); } catch(e) {}
                      
                      return (
                        <tr key={item.id}>
                          <td>{item.name}</td>
                          <td>{apiData.page_name || apiData.page_id}</td>
                          <td>{apiData.form_name || apiData.form_id}</td>
                          <td>
                            <span className={`badge bg-${item.status === Const.Active ? 'success' : 'danger'}`}>
                              {item.status === Const.Active ? 'Active' : 'Disabled'}
                            </span>
                          </td>
                          <td>
                            <Button 
                              variant="info" 
                              size="sm" 
                              className="me-2"
                              onClick={() => this.props.navigate(`mapping/${item.id}`)}
                            >
                              Edit
                            </Button>
                            <Button 
                              variant="danger" 
                              size="sm"
                              onClick={() => this.setState({ showDelete: true, deleteId: item.id })}
                            >
                              Delete
                            </Button>
{/*                             
                            // TODO: future feature
                            <Button variant="warning" size="sm" className="mr-2"
                              onClick={() => this.props.navigate(`backfill/${item.id}`)}>
                              Backfill
                            </Button> */}
                            <NavLink to={`/setting/third-party/api-log/${item.id}`} className="buttons add"><FaCogs /> Logs</NavLink>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </div>
          </div>
        )}

        <DeleteModal 
          show={showDelete} 
          onHide={this.closeDelete} 
          onConfirm={this.deleteMapping}
        />
      </div>
    );
  }
}

export default withRouter(withFacebookAuth(FacebookList));